import { DirectiveBinding } from 'vue';

export default {
    name: 'resize-init',
    mounted(el: Element, binding: DirectiveBinding) {
        window.addEventListener('resize', binding.value);
    },
    beforeUnmount(el: Element, binding: DirectiveBinding) {
        window.removeEventListener('resize', binding.value);
    },
};
